const Phone = (number, lang) => {
  if (lang === 'fi') {
    return number;
  } else {
    return '+358 ' + number.slice(1);
  }
};
export default Phone;
